import '@/assets/css/style.scss';
if (import.meta.env.VITE_INCLUDE_COMMON === 'true') {
  import('@/assets/css/global-footer.css');
  import('@/assets/js/common/loadHeaderFooter.js').then(module => {
    const loadHeaderFooter = module.default;
    loadHeaderFooter();
  });
  import('@/assets/js/common/components/login.js');
}

import { createApp, ref, onMounted } from './vue.esm-browser.prod.js';
import { typeData } from './data';
import { Anchor, Tab, Collapse } from './common/components/k-plugins';
import LazyLoad from 'vanilla-lazyload';
// import Swiper bundle with all modules installed
import { Swiper } from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';
import gsapAnimation from './common/gsapAnimation';

const swiperHandler = {};
swiperHandler.category = function () {
  $('.category-gallery').each((index, el) => {
    const swiperEl = $(el).find('.category-swiper')[0];
    const paginationEl = $(el).find('.category-swiper .swiper-pagination')[0];
    const prevEl = $(el).find('.category-swiper .swiper-button-prev')[0];
    const nextEl = $(el).find('.category-swiper .swiper-button-next')[0];
    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: false,
      loop: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
    });
  });
};
swiperHandler.all = function () {
  this.category();
};

function productColorSwitch() {
  function colorChange(e) {
    e.stopPropagation();
    const href = $(this).attr('data-href');
    const productCard = $(this).parents('.product-card');
    const clickIndex = $(this).index();
    $(this).siblings('li').removeClass('active');
    $(this).addClass('active');
    productCard.find('.color-box').removeClass('active');
    productCard.find('.color-box').eq(clickIndex).addClass('active');
    productCard.find('.name p').removeClass('active');
    productCard.find('.name p').eq(clickIndex).addClass('active');
    productCard.find('.price p').removeClass('active');
    productCard.find('.price p').eq(clickIndex).addClass('active');
    productCard.find('.fakeLink').removeClass('active');
    productCard.find('.fakeLink').eq(clickIndex).addClass('active');
  }
  $('.product-card .color-chips > li').on('click', colorChange);
}

function materialColorSwitch() {
  function colorChange(e) {
    e.stopPropagation();
    const parentsItem = $(this).parents('.item');
    const title = $(this).attr('data-title');
    const description = $(this).attr('data-description');
    const headerColorBox = parentsItem.find('.header .color-box');
    const mainColorBox = parentsItem.find('.main .color-box');
    const thumbnailColorBox = parentsItem.find('.thumbnail .color-box');
    const clickIndex = $(this).index();
    $(this).siblings('li').removeClass('active');
    $(this).addClass('active');
    headerColorBox.removeClass('active');
    headerColorBox.eq(clickIndex).addClass('active');
    mainColorBox.removeClass('active');
    mainColorBox.eq(clickIndex).addClass('active');
    thumbnailColorBox.removeClass('active');
    thumbnailColorBox.eq(clickIndex).addClass('active');
    parentsItem.find('.detail .title').text(title);
    parentsItem.find('.detail .description').text(description);
  }
  $('.material-card .color-chips > li').on('click', colorChange);
}

const productListSeeMore = {
  detectListHeight() {
    $('.product-list.display-limit').each((index, el) => {
      const firstChild = $(el).children();
      const contentH = firstChild.innerHeight();
      const overLimit = contentH > $(el).innerHeight();
      const moreBlock = $(el).siblings('.more-block');
      if (overLimit) {
        $(el).addClass('is-overlimit');
        $(el).css('--max-height', `${contentH}px`);
        moreBlock.addClass('show');
      } else {
        $(el).removeClass('is-overlimit');
        $(el).css('--max-height', '');
        moreBlock.removeClass('show');
      }
    });
  },
  seeMoreHandler() {
    const productList = $(this).parents('.product-block').find('.product-list.display-limit');
    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
      productList.removeClass('show-all');
    } else {
      $(this).addClass('open');
      productList.addClass('show-all');
    }
  },
  update() {
    this.detectListHeight();
  },
  init() {
    const _this = this;
    _this.detectListHeight();
    $(window).on('resize', productListSeeMore.detectListHeight);
    $('.product-list.display-limit + .more-block').on('click', '.more-btn', _this.seeMoreHandler);
  },
};

function fixedAnchorHandler() {
  const fixedAnchor = $('.fixed-anchor');
  let lastActiveIndex;
  let newActiveIndex;
  function detectShow() {
    const scrollTop = $(window).scrollTop();
    const lineupList = $('.fan-goods');
    const lineupListOffsetTop = lineupList.offset().top;
    const specialReport = $('section.special-report');
    const specialReportOffsetTop = specialReport.offset().top;
    if (scrollTop >= lineupListOffsetTop) {
      fixedAnchor.addClass('show');
    } else {
      fixedAnchor.removeClass('show');
    }
    if (scrollTop >= specialReportOffsetTop) {
      fixedAnchor.removeClass('show');
    }
  }
  function scrollspy() {
    const scrollTop = $(window).scrollTop();
    const sections = $('.goods-block');
    const navLinks = $('.fixed-anchor .anchor-list .item');
    sections.each((index, section) => {
      const top = $(section).offset().top - 100;
      const bottom = top + $(section).outerHeight();
      if (scrollTop >= top && scrollTop <= bottom) {
        const currentCategory = $(section).attr('data-category');
        navLinks.removeClass('active');
        const $activeItem = $(`.fixed-anchor .anchor-list .item[data-anchor=".goods-block[data-category='${currentCategory}']"]`);
        $activeItem.addClass('active');
      }
    });
    // 存入當前 active 的 item 的 index
    newActiveIndex = $('.fixed-anchor .anchor-list .item.active').index();
    // 若 index 改變時才會觸發 scroll animate
    if (newActiveIndex !== null && newActiveIndex !== lastActiveIndex) {
      lastActiveIndex = newActiveIndex;
      const targetWidth = navLinks.outerWidth();
      const scrollLeft = newActiveIndex * targetWidth - fixedAnchor.width() / 2 + targetWidth / 2;
      $('.fixed-anchor').animate(
        {
          scrollLeft: scrollLeft,
        },
        500,
      );
    }
  }
  function scrollHandler() {
    detectShow();
    scrollspy();
  }
  $(window).on('scroll', scrollHandler);
}

createApp({
  setup() {
    const typeDataRef = ref(typeData);
    onMounted(() => {
      const lazyLoadInstance = new LazyLoad({});
      const anchor = new Anchor('[data-anchor]');
      const collapse = new Collapse('[data-collapse]', {
        firstOpen: false,
      });
      const tab = new Tab('[data-tab]');
      swiperHandler.all();
      productColorSwitch();
      materialColorSwitch();
      productListSeeMore.init();
      fixedAnchorHandler();
      gsapAnimation();
    });
    return {
      typeDataRef,
    };
  },
}).mount('#main');
